import React from 'react';
import { fetchProgramList as fetchProgramListService } from '../../services/programService';
import { Program } from '../../state/program';
import AsyncAutoComplete, { AsyncAutoCompleteOption } from './AsyncAutoComplete';

interface ProgramComboBoxProps {
  handleChange: (result: Program & AsyncAutoCompleteOption) => void;
  selectedValue: Program | null | { label: string | null; value: string | null };
  isDisabled?: boolean;
  error?: boolean;
  helperText?: string;
  creatable?: boolean;
}

const ProgramComboBox: React.FC<ProgramComboBoxProps> = (props) => {
  const {
    handleChange,
    selectedValue,
    isDisabled = false,
    error,
    helperText,
    creatable = false,
  } = props;

  const programPromiseOptions = async (inputValue: string) => {
    const { data: rows } = await fetchProgramListService({
      filters: { 'Name.startsWith': inputValue },
      paging: { pageNumber: 0, pageSize: 10 },
    });

    return rows;
  };

  return (
    <AsyncAutoComplete
      name="Program"
      value={selectedValue}
      getOptionValue={(option: Program & AsyncAutoCompleteOption) => {
        return option.id ? option.id!.toString() : option.value;
      }}
      getOptionLabel={(option: Program & AsyncAutoCompleteOption) => {
        return option.name ? option.name : option.label;
      }}
      promiseOptions={programPromiseOptions}
      placeholder={'Type Program Name'}
      handleChange={handleChange}
      isDisabled={isDisabled}
      error={error}
      helperText={helperText}
      creatable={creatable}
    />
  );
};

export default ProgramComboBox;
